export default (text) => {
    const words = text.split('-');
    const titleWords = words.map((word)=> {
        if(word[0] && word.slice(1)){
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
        }
    });
    return titleWords.join(' ');
};